import React from 'react';
import { Box, Button } from '@mui/material';
import left from '../assets/icons/left.svg';
import right from '../assets/icons/right.svg';
import styles from '../pages/informationManager/manager.module.css';

function PrevAndNextBtn({ handlePrevious, handleNext, currentPage, totalPage}) {
    
    return (
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', marginTop: 2 }}>
            <Button
                variant="contained"
                onClick={()=>handlePrevious(1)}
                sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 1.5,
                    padding: 0,
                    minWidth: 0,
                    marginRight: 1,
                    backgroundColor: currentPage === 1 ? "#a4dede !important" : "#49bbbd",
                    color: "#ffffff !important" 
                }}
                disabled={currentPage === 1}
            >
                <img src={left} alt="Previous" className={styles.directIcon} />
            </Button>
            <Button
                variant="contained"
                onClick={()=>handleNext(1)}
                sx={{
                    width: 40,
                    height: 40,
                    borderRadius: 1.5,
                    minWidth: 0,
                    padding: 0,
                    backgroundColor: currentPage >= totalPage ? "#a4dede !important" : "#49bbbd",
                    color: "#ffffff !important" 
                }}
                disabled={currentPage >= totalPage}
            >
                <img src={right} alt="Next" className={styles.directIcon} />
            </Button>

        
        </Box>
    );
}

export default PrevAndNextBtn;
